"use client";

import { FeedPostDtoWithOgMetadata } from "@/api/posts/types";
import { FeedPost } from "../FeedPost";
import FeedRepost from "../FeedRepost";
import ArrowRight from "@/assets/icons/arrow-right.svg";
import { useRouter } from "next/navigation";

interface Props {
  post: FeedPostDtoWithOgMetadata;
  referer?: string;
}

const FeedDetail = ({ post, referer }: Props) => {
  const router = useRouter();

  return (
    <div className="mb-20">
      <div className="flex items-center gap-x-8 mb-6">
        <button
          onClick={() =>
            !referer ||
            new URL(referer).host !==
              new URL(process.env.NEXT_PUBLIC_URL! as string).host
              ? router.push("/feed/global")
              : router.back()
          }
        >
          <ArrowRight className="w-5 fill-primary rotate-180" />
        </button>
        <span className="font-semibold">Post</span>
      </div>
      {!!post.repost ? (
        <FeedRepost feedPost={post} />
      ) : (
        <FeedPost feedPost={post} />
      )}
    </div>
  );
};

export default FeedDetail;
